module.exports = __webpack_public_path__ + "static/media/ribbon_grey.3590b656.svg";